import React, { Component } from 'react';
import _ from 'lodash';
import { EventKeyEnum } from 'common/enums/DomEnums';

export const KeyEventHandler = Element => {
    return class ArrowStepperList extends Component {
        static defaultProps = {
            useCapture: false
        };

        constructor(props) {
            super(props);
            this._onKeyDown = _.throttle(this._onKeyDown.bind(this), 300);
        }

        UNSAFE_componentWillMount() {
            window.addEventListener(
                'keydown',
                this._onKeyDown,
                this.props.useCapture
            );
        }

        componentWillUnmount() {
            window.removeEventListener('keydown', this._onKeyDown);
        }

        _onKeyDown(event) {
            // The above cases all prevent default event event behavior.
            // This is to keep the grid from scrolling after the snap-to update.

            switch (event.key) {
                case EventKeyEnum.ArrowDown:
                    if (this.props.onNext) this.props.onNext(event);
                    break;
                case EventKeyEnum.ArrowUp:
                    if (this.props.onPrevious) this.props.onPrevious(event);
                    break;
                case EventKeyEnum.Escape:
                    if (this.props.onEscape) this.props.onEscape(event);
                    break;
                case EventKeyEnum.Esc:
                    if (this.props.onEscape) this.props.onEscape(event);
                    break;
                case EventKeyEnum.Enter:
                    if (this.props.onEnter) this.props.onEnter(event);
                    break;
                case EventKeyEnum.Tab:
                    if (this.props.onTab) this.props.onTab(event);
                    break;
            }
        }
        getInternalRef = ref => {
            this.interalRef = ref;
            this.props.getElementRef && this.props.getElementRef(ref);
        };
        render() {
            return <Element ref={this.getInternalRef} {...this.props} />;
        }
    };
};
export default KeyEventHandler;
